const bool = (v: string | undefined, fallback: boolean) =>
  v === undefined ? fallback : v.toLowerCase() === 'true';

const num = (v: string | undefined, fallback: number) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

export const appConfig = {
  siteName: import.meta.env.VITE_SITE_NAME ?? 'Democracy on the Ballot',
  siteUrl: import.meta.env.VITE_SITE_URL ?? 'https://DemocracyOnTheBallot.org',
  tagline: import.meta.env.VITE_SITE_TAGLINE ?? '',
  homeStatement: import.meta.env.VITE_HOME_STATEMENT ?? '',
  footerNote: import.meta.env.VITE_FOOTER_NOTE ?? '',
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL ?? 'info@DemocracyOnTheBallot.org',
  contentJsonPath: import.meta.env.VITE_CONTENT_JSON_PATH ?? '/content/organized_website_content.json',
  /** Client-side TTL before re-fetching content from the origin (default 6 hours). */
  contentRevalidateMs: num(import.meta.env.VITE_CONTENT_REVALIDATE_MS, 6 * 60 * 60 * 1000),
  fetchTimeoutMs: num(import.meta.env.VITE_FETCH_TIMEOUT_MS, 30000),
  relatedTopicsLimit: num(import.meta.env.VITE_RELATED_TOPICS_LIMIT, 8),
  searchMinChars: num(import.meta.env.VITE_SEARCH_MIN_CHARS, 2),
  searchResultsLimit: num(import.meta.env.VITE_SEARCH_RESULTS_LIMIT, 40),
  enableSearch: bool(import.meta.env.VITE_ENABLE_SEARCH, true),
  showSourceAttribution: bool(import.meta.env.VITE_SHOW_SOURCE_ATTRIBUTION, true),
  enableClarity: bool(import.meta.env.VITE_ENABLE_CLARITY, false),
  clarityProjectId: import.meta.env.VITE_CLARITY_PROJECT_ID ?? '',
} as const;

export const CATEGORY_LABELS: Record<string, string> = {
  policy_human_impact: 'Policy & Human Impact',
  executive_order: 'Executive Order',
  pardon_or_commutation: 'Pardon / Commutation',
  corruption_claim: 'Accountability Claim',
};
